import React from 'react';
import TableRowComponent from './TableRow';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Box,
} from '@mui/material';

const Table = ({ data, handleDelete, selectedRows, setSelectedRows, downloadableData }) => {
  console.log("selectedRows", selectedRows);

  const handleSelectRow = (userId) => {
    setSelectedRows((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(userId)) {
        newSelected.delete(userId);
      } else {
        newSelected.add(userId);
      }
      return newSelected;
    });
  };

  const handleSelectAll = (e) => {
    setSelectedRows((prev) => {
      const newSelected = new Set(prev);
      if (e.target.checked) {
        data.forEach((user) => newSelected.add(user.id));
      } else {
        data.forEach((user) => newSelected.delete(user.id));
      }
      return newSelected;
    });
  };

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: 3,
        overflow: 'hidden',
        boxShadow: '0 10px 25px rgba(0,0,0,0.08)',
        border: '1px solid rgba(0,0,0,0.05)',
        backgroundColor: 'white',
      }}
    >
      <TableContainer
        component={Paper}
        sx={{
          background: 'linear-gradient(to bottom, #f9fafc, #ffffff)',
          '&::-webkit-scrollbar': {
            height: '6px',
            width: '6px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#1976d2',
            borderRadius: '3px',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            background: 'linear-gradient(90deg, #f8f9fa 0%, #ffffff 100%)',
            borderBottom: '1px solid rgba(0,0,0,0.05)',
          }}
        >
          <Box
            sx={{
              fontSize: '1.1rem',
              fontWeight: 600,
              color: '#2d3748',
              pl: 1,
            }}
          >
            User Records
            <Box sx={{ fontSize: '0.85rem', fontWeight: 400, color: '#555' }}>
              Selected IDs: {selectedRows.size}
            </Box>
          </Box>
        </Box>

        <MuiTable
          sx={{
            minWidth: 650,
            '& .MuiTableCell-root': {
              borderColor: 'rgba(0,0,0,0.03)',
            },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                background: 'linear-gradient(90deg, #1976d2 0%, #2196f3 100%)',
                '& th': {
                  borderBottom: 'none',
                },
              }}
            >
              <TableCell sx={{ width: 60 }}>
                <Checkbox
                  sx={{
                    color: 'rgba(255,255,255,0.7)',
                    '&.Mui-checked': { color: 'white' },
                  }}
                  onChange={handleSelectAll}
                  checked={data.length > 0 && data.every((user) => selectedRows.has(user.id))}
                />
              </TableCell>

              {[
                'ID',
                'User Name',
                'Email',
                'Event Name',
                'Created At',
                'UTM Info',
                'Location',
              ].map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '0.8rem',
                    py: 1.5,
                    textTransform: 'uppercase',
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {data.length > 0 ? (
              data.map((user, index) => (
                <TableRowComponent
                  key={user.id}
                  user={user}
                  handleDelete={handleDelete}
                  handleSelectRow={handleSelectRow}
                  isChecked={selectedRows.has(user.id)}
                />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center" sx={{ py: 6 }}>
                  <Box sx={{ opacity: 0.5 }}>No records found</Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </Box>
  );
};

export default Table;
